// F-051: standard incident types instead of free text.
export const incidentTypes=['Fire','Structural','Fire safety system failure','Gas or electrical','Water ingress','Lift','Cladding or external wall','Near miss','Other'] as const;
// F-051: a High or Critical incident starts with the escalation Action ticked (it can still be unticked).
export const escalatesByDefault=(severity:string)=>severity==='High'||severity==='Critical';
// F-055: a risk review date defaults to twelve months ahead (local calendar date, YYYY-MM-DD).
export const twelveMonthsAhead=(from=new Date())=>{
  const next=new Date(from.getFullYear()+1,from.getMonth(),from.getDate());
  return `${String(next.getFullYear()).padStart(4,'0')}-${String(next.getMonth()+1).padStart(2,'0')}-${String(next.getDate()).padStart(2,'0')}`;
};
// F-062: choosing a document version pre-selects the Current entry for the same document title, when there is exactly one.
export const supersededEntry=(entries:Array<{id:string;title:string;lifecycle_status:string;document_visible?:boolean}>,title:string)=>{
  const matches=entries.filter(g=>g.lifecycle_status==='Current'&&g.document_visible===true&&g.title===title);
  return matches.length===1?matches[0]:undefined;
};
